const ORDEM_TIPO = ["PROCEDIMENTO", "MEDICAMENTO", "ADICIONAL", "DESLOCAMENTO"];

function indiceTipo(tipo) {
  const indice = ORDEM_TIPO.indexOf(tipo);
  return indice === -1 ? ORDEM_TIPO.length : indice;
}

export function ordenarProcedimentos(lista) {
  return [...lista].sort((a, b) => {
    const diffTipo = indiceTipo(a.tipo) - indiceTipo(b.tipo);
    if (diffTipo !== 0) return diffTipo;
    return (a.nome || "").localeCompare(b.nome || "", "pt-BR");
  });
}

export function mesclarProcedimentosAtivosComVinculados(ativos, vinculados = []) {
  const idsAtivos = new Set(ativos.map((p) => p.id));
  const vinculadosForaDoCatalogoAtivo = vinculados.filter((p) => !idsAtivos.has(p.id));
  return ordenarProcedimentos([...vinculadosForaDoCatalogoAtivo, ...ativos]);
}
